import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildEngines, buildKeywords } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function EnginesPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const engines = buildEngines(ranged);
  const keywords = buildKeywords(ranged);
  const total = engines.reduce((sum, s) => sum + s.value, 0);

  if (!currentSite) {
    return <EmptyState title="先添加一个站点" desc="添加站点后可查看百度、360、搜狗等搜索引擎带来的流量。" />;
  }

  return (
    <div>
      <PageHeader
        title="搜索引擎"
        desc="拆解各搜索引擎贡献的浏览量，便于做 SEO 投放判断。"
        range={range}
        extra={
          <ExportButton
            filename={`${currentSite.domain}-engines.csv`}
            columns={['搜索引擎', '浏览量', '占比']}
            rows={engines.map((e) => [
              e.name,
              formatNumber(e.value),
              total ? `${Math.round((e.value / total) * 100)}%` : '0%',
            ])}
          />
        }
      />

      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="text-sm font-semibold text-foreground-900">引擎带来的浏览量</h2>
        <div className="mt-4 h-72">
          {engines.length === 0 ? (
            <p className="text-sm text-foreground-500">当前时段暂无搜索引擎流量</p>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={engines}>
                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} width={36} />
                <Tooltip />
                <Bar dataKey="value" fill="#E25A3C" radius={[6, 6, 0, 0]} name="浏览量" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>

      <div className="mt-4 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <div className="px-5 py-3 border-b border-background-200">
          <h2 className="text-sm font-semibold text-foreground-900">引擎明细</h2>
        </div>
        <StatTable
          columns={['搜索引擎', '浏览量', '占比', '带来搜索词数']}
          rows={engines.map((e) => [
            e.name,
            formatNumber(e.value),
            total ? `${Math.round((e.value / total) * 100)}%` : '0%',
            formatNumber(keywords.filter((k) => k.engine === e.name).length),
          ])}
        />
      </div>
    </div>
  );
}
